import { alpha } from '../constants/alpha'

export const colors = {
  white: '#FFFFFF',
  white98: '#FAFAFA',
  white94: '#F0F0F0',
  white88: '#E0E0E0',

  greyLighter: '#F5F5F5',
  greyLight: '#EBEBEB',
  greyDark: '#474747',
  greyDarker: '#202020',
  brandText: '#2B2A29',
  text: '#2B2A29',
  black: '#000000',

  brandLighter: '#7477C6',
  brandLight: '#5E62BD',
  brand: '#2b2c69',
  brandDark: '#26275E',
  brandDarker: '#2D624C',

  red: '#ff223a',

  gradientLight: `linear-gradient(to bottom right, 
    ${'#2B2A29'.concat(alpha[2])}, 
    ${'#2B2A29'.concat(alpha[10])}, 
    ${'#2B2A29'.concat(alpha[30])})`,
}
